/**
 * @ngdoc service
 * @name app.profileService
 * @description
 * # profileService
 * Service to talk with backend api.
 * @requires app.apiService
 * @requires constants:config
 **/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * regionService
\*---------------------------------------------------------*/
/* @ngInject */
function profileService(apiService, config) {
  // APIs
  /**
   * @ngdoc
   * @name app.profileService#getprofile
   * @methodOf app.profileService
   * @example
   * ``` js
   * profileService.getprofile();
   * ```
   * @description
   * Service to talk with backend api.
   * It forms a string url using config relative base url, '/profile/info' string.
   * It will call apiService.wrap function with the string formed as a param.
   * @returns {httpPromise} Promise that will resolve into an object with the user profile information.
   **/
  this.getProfile = () => {
    return apiService.wrap(config.relBaseUrlAPi + '/profile/info',
      {}, 'profile');
  };
}

profileService.$inject = [
  'apiService',
  'config'
];

const api = angular
  .module('profileService', ['config', 'apiService'])
  .service('profileService', profileService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/profile.js
 **/